import { isEmpty } from 'lodash-es'
import { useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import styled from 'astroturf/react'
import { parseQuery } from '@calendly/http-tools'
import { FieldLabel, FieldError, Fieldset } from '@calendly/form/parts'

import LocationChoice from 'components/location/multiple/location_choice'
import {
  locationConfigurationsSelector
} from 'selectors/event_type'
import {
  inviteeLocationChoiceErrorsSelector,
  locationLabelSelector
} from 'selectors'
import {
  selectLocationConfiguration
} from 'actions/scheduling'
import { dismissValidationError } from 'actions/errors'
import { useI18n } from 'locales'
import _Choices from "index-Choices.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/location/multiple/index.js?styleId=Choices";


const Choices = /*#__PURE__*/styled('div', null, {
  displayName: "Choices",
  styles: _Choices
})

const LocationChoices = ({
  locationConfigurations,
  onLocationSelected,
  setInitialLocation,
  locationParam,
  errors
}) => {
  const { i18n } = useI18n()
  const labelText = useSelector(locationLabelSelector)

  useEffect(() => {
    if (!locationParam) return

    const locationIndex = parseInt(locationParam, 10)

    if (locationIndex) {
      const locationConfiguration = locationConfigurations[locationIndex - 1]
      setInitialLocation(locationConfiguration)
    }
  }, [locationConfigurations, locationParam, setInitialLocation])

  const handleOptionCheck = (locationConfiguration) => () => {
    onLocationSelected(locationConfiguration)
  }

  const hasError = !isEmpty(errors)
  const errorId = hasError ? 'location-error' : undefined

  return (
    <Choices data-component="location-choices">
      <Fieldset
        role="radiogroup"
        aria-required
        aria-invalid={hasError}
        aria-describedby={errorId}
      >
        <legend>
          <FieldLabel text={labelText} isRequired />
        </legend>
        {
          locationConfigurations.map((locationConfiguration) => (
            <LocationChoice
              key={locationConfiguration.id}
              locationConfiguration={locationConfiguration}
              onChange={handleOptionCheck(locationConfiguration)}
            />
          ))
        }
      </Fieldset>
      {
        !isEmpty(errors) && (
          <FieldError text={i18n.t('booking.location.errors.choice.blank')} id={errorId} />
        )
      }
    </Choices>
  )
}

const mapStateToProps = (state) => ({
  locationConfigurations: locationConfigurationsSelector(state),
  locationParam: parseQuery(window.location.search).location,
  errors: inviteeLocationChoiceErrorsSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
  onLocationSelected: (locationConfiguration) => {
    dispatch(selectLocationConfiguration(locationConfiguration))
    dispatch(dismissValidationError('event', 'location_choice'))
    dispatch(dismissValidationError('event', 'location'))
    dispatch(dismissValidationError('event', 'phone_number'))
  },
  setInitialLocation: (locationConfiguration) => {
    dispatch(selectLocationConfiguration(locationConfiguration))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationChoices)
